<template>
  <div class="c-categories-dropdown">
    <div
      class="c-categories-dropdown__header"
      @mouseenter="switchPanel"
      @click="togglePanel"
    >
      <component
        :is="isCategorySelected ? 'h1' : 'h3'"
        class="o-typography__headline3"
        :class="{ 'u-color-primary': openPanel }"
      >
        {{ dropdownHeader }}
      </component>
      <i
        class="o-icon o-icon--right c-categories-dropdown__arrow"
        :class="{ 'is-open' : openPanel }"
      ></i>
    </div>
    <div
      class="c-categories-dropdown__panel"
      :class="{ 'is-visible' : openPanel }"
      @mouseleave="switchPanel"
    >
      <div class="c-categories-dropdown__backdrop u-mobile-only"></div>
      <v-styled-scroll
        ref="categories-wrapper"
        max-page-height
      >
        <div
          v-for="row in categoryRows"
          class="c-categories-dropdown__row"
        >
          <div
            v-for="category in categoriesInRow(row)"
            class="c-categories-dropdown__element"
          >
            <router-link
              :to="category.route"
              class="o-typography--action o-typography--wrap c-categories-dropdown__text u-uppercase"
              @click.native="close"
            >
              {{ category.name }}
            </router-link>
          </div>
        </div>
      </v-styled-scroll>
    </div>
  </div>
</template>
<script>
  import { VStyledScroll } from '@/shared/components';

  export default {
    components: {
      VStyledScroll,
    },
    props: {
      categories: Array,
      dropdownHeader: String,
      isCategorySelected: Boolean,
    },
    data() {
      return {
        openPanel: false,
      };
    },
    computed: {
      categoryRows() {
        return Array.from(Array(Math.ceil(this.categories.length / this.itemsPerRow)).keys());
      },
      itemsPerColumn() {
        return Math.ceil(this.categories.length / this.itemsPerRow);
      },
      itemsPerRow() {
        return this.$window.isMobileView ? 1 : 3;
      },
    },
    watch: {
      categories() {
        this.openPanel = false;
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs['categories-wrapper']?.perfectScroll?.update();
      });
    },
    methods: {
      categoriesInRow(row) {
        const inRow = [];
        for (let column = 0; column < this.itemsPerRow; column++) {
          const index = column * this.itemsPerColumn + row;

          if (index < this.categories.length) {
            inRow.push(this.categories[index]);
          }
        }

        return inRow;
      },
      switchPanel() {
        this.openPanel = !this.openPanel;
      },
      togglePanel() {
        if (!this.$window.isMobileDevice) {
          return;
        }

        this.switchPanel();
      },
      close() {
        this.openPanel = false;
      },
    },
  };
</script>
